import React from 'react';
import Icon from '../../../components/AppIcon';

const AlertsPanel = ({ clients }) => {
  const criticalIssues = clients?.filter(c => (c?.complianceScore || 0) < 70 || c?.criticalViolations > 0);
  const paymentIssues = clients?.filter(c => {
    if (!c?.nextBillingDate) return true;
    const daysUntilBilling = Math.floor(
      (new Date(c?.nextBillingDate) - new Date()) / (1000 * 60 * 60 * 24)
    );
    return daysUntilBilling < 0;
  });

  if (criticalIssues?.length === 0 && paymentIssues?.length === 0) {
    return null;
  }

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-6 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="AlertTriangle" size={20} className="text-warning" />
        <h2 className="text-lg font-bold text-foreground">Critical Alerts</h2>
      </div>

      <div className="space-y-3">
        {/* Payment Failures */}
        {paymentIssues?.length > 0 && (
          <div className="bg-error/10 border border-error/20 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <Icon name="CreditCard" size={18} className="text-error mt-0.5" />
              <div className="flex-1">
                <h3 className="text-sm font-medium text-foreground mb-1">Payment Failures</h3>
                <p className="text-sm text-muted-foreground">
                  {paymentIssues?.length} client{paymentIssues?.length > 1 ? 's have' : ' has'} overdue payments requiring immediate attention
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Compliance Violations */}
        {criticalIssues?.length > 0 && (
          <div className="bg-warning/10 border border-warning/20 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <Icon name="AlertCircle" size={18} className="text-warning mt-0.5" />
              <div className="flex-1">
                <h3 className="text-sm font-medium text-foreground mb-1">Compliance Violations</h3>
                <p className="text-sm text-muted-foreground">
                  {criticalIssues?.length} client{criticalIssues?.length > 1 ? 's have' : ' has'} compliance scores below 70% or critical violations
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AlertsPanel;